<template>
  <el-dialog
    title="阿里巴巴-批量导入"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    modal-append-to-body
    width="800"

    :before-close="handleClose">

    <el-table :data="tableList" height="500">
      <el-table-column type="index"></el-table-column>
      <el-table-column label="产品ID" prop="id" header-align="center" min-width="150">
        <template #default="scope">
          <div style="cursor: pointer" @click="showProductInfo(scope.row.id)">{{ scope.row.id }}</div>
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="title" header-align="center" min-width="200">
        <template #default="scope">
          <div class="single-line-ellipsis" :title="scope.row.title">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center" min-width="80"></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">

    <el-button size="mini" v-if="productIds.length==0" type="primary" @click="onSubmit">验证商品</el-button>
    <el-button size="mini" type="primary" v-else @click="toCloneProduct">确认转自营</el-button>
      <el-button size="mini" @click="handleClose">取 消</el-button>
    </span>
    <alibaba-product-info ref="alibabaProductInfo"></alibaba-product-info>
    <el-dialog title="运费模板" :visible.sync="freightViable" append-to-body :close-on-click-modal="false" width="500px"
               @close="resetForm_freight('zhuanData')">
      <el-form :model="zhuanData" :rules="rules_freight" ref="zhuanData" label-width="100px">
        <el-form-item label="运费模板:" prop="freight_template_ids">
          <el-select v-model="zhuanData.freight_template_ids" multiple placeholder="请选择" size="small"
                     style="width: 100%;">
            <el-option v-for="item in freightList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <div class="btnbox">
          <el-button @click="resetForm_freight('zhuanData')" size="small">取消</el-button>
          <el-button @click="toCloneProduct_submit('zhuanData')" type="primary" size="small">确定导入
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import alibabaProductApi from "../api";
import {Loading} from "element-ui";
import AlibabaProductInfo from "../alibabaProductInfo.vue";

export default {
  components: {AlibabaProductInfo},
  data() {
    return {
      freightViable: false,
      listMap: new Map,
      list: [],
      dialogVisible: false,
      productIds: [],
      freightList: [],
      zhuanData: {
        freight_template_ids: [],
        product_ids: [],
        is_all: 0,
        channel_id: '',
        channel_type: '',
        classify_id: ''
      },
      rules_freight: {
        freight_template_ids: [
          {
            required: true,
            message: '请选择运费模板',
            trigger: ['change', 'blur']
          }
        ],
      },
    }
  },

  computed: {

    tableList() {
      let list = [...this.listMap];
      return list.map(item => {
        return item[1];
      });
    }
  },
  methods: {
    // 获取运费模板
    getFreightList() {
      this.$get(this.$api.selectTemplate).then((res) => {
        if (res.status == 200) {
          this.freightList = res.data;
          this.freightViable = true
        }
      });
    },
    resetForm_freight(formName) {
      this.$refs[formName].resetFields();
      this.freightViable = false
    },
    showProductInfo(id) {
      this.$refs.alibabaProductInfo.open(id);
    },
    handleClose() {
      this.productIds = [];
      this.dialogVisible = false;
    },
    open(list) {

      if (list.size === 0) {
        this.$message.error("请选择要导入的商品")
        return
      }
      this.productIds = [];
      this.dialogVisible = true;
      this.listMap = list;
    },
    onSubmit() {

      let loadingInstance = Loading.service({
        text: "阿里巴巴-商品验证中..."
      });
      let selIds = [...this.listMap.keys()];
      alibabaProductApi.checkSupport(selIds).then(res => {
        if (res.status == 200) {
          if (res.data.platform) {
            this.zhuanData.channel_id = res.data.platform.platform_authorize_id
            this.zhuanData.channel_type = res.data.platform.type
          } else {
            this.$confirm('您未订购阿里巴巴相关服务！确认前往阿里巴巴订购？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.open(res.data.appShopUrl, "_blank");
            }).catch(() => {

            });
            return
          }

          let relationOfferIds = res.data.relationOfferIds ? res.data.relationOfferIds : [];
          let notSupportIds = res.data.notSupportIds ? res.data.notSupportIds : [];
          let notSupportIdsErr = res.data.notSupportIdsErr ? res.data.notSupportIdsErr : [];
          let productIds = res.data.productIds ? res.data.productIds : [];
          this.listMap.forEach((value, key, map) => {
            if (relationOfferIds.includes(key)) {
              value.status = "已入库";
              //this.listMap.set(key, );
            }
            if (notSupportIds.includes(key)) {
              value.status = "不是分销商品";
              //this.listMap.set(key, );
            }
            if (productIds.includes(key)) {
              value.status = "正常";
              //this.listMap.set(key, );
            }

          })
          if (productIds.length > 0) {
            this.productIds = productIds;
          }
        }
      }).finally(() => {
        loadingInstance.close();
      })
    },

    // 转为自营商品
    toCloneProduct() {
      if (this.productIds.length > 0) {
        this.getFreightList()
        //this.freightViable = true
      } else {
        this.$message.error('请选择要转为自营的商品');
        return
      }
    },
    toCloneProduct_submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          if (this.zhuanData.is_all == 0) {
            if (this.productIds.length > 0) {
              this.zhuanData.product_ids = this.productIds
            } else {
              this.$message.error('请选择要转为自营的商品');
              return
            }
          } else {
            this.zhuanData.product_ids = []
          }
          let loadingInstance = Loading.service({
            text: "阿里巴巴-商品导入中..."
          });
          this.$post(this.$api.cloneProduct, this.zhuanData).then((res) => {
            this.zhuanData.product_ids = []

            if (res.status == 200) {
              this.resetForm_freight(formName)
              // this.selectCro(false)
              this.$message({
                message: res.msg,
                type: 'success'
              });
              //this.search();
            }
          }).finally(() => {
            loadingInstance.close()
          });
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style scoped>
.single-line-ellipsis {
  width: 100%; /* 限制容器宽度 */
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */

}
</style>



// WEBPACK FOOTER //
// src/views/alibaba/product/components/supportProducts.vue